import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Card } from "../ui/Card";
import { EmptyState } from "../ui/EmptyState";
import { allows, deniedMessage, homePath } from "./access";
import { useCurrentMe } from "./auth";
import { findScreen } from "./screens";
import { useDocumentTitle } from "./title";

/**
 * Between the shell and the screens: sends the admin to the Admin page, and says so in plain words
 * when a screen is not open to the person's role. The server refuses the requests as well.
 */
export function AccessOutlet() {
  const me = useCurrentMe();
  const { pathname } = useLocation();
  const screen = findScreen(pathname);
  useDocumentTitle(screen?.title);

  if (pathname === "/" && homePath(me) !== "/") return <Navigate to={homePath(me)} replace />;

  if (screen && !allows(me, screen.access)) {
    return (
      <Card aria-labelledby="screen-title">
        <h1 id="screen-title">{screen.title}</h1>
        <EmptyState title="This screen is not available to you">{deniedMessage(me, screen.access)}</EmptyState>
      </Card>
    );
  }
  return <Outlet />;
}
